import React from 'react';
import ReactDOM from 'react-dom';
import CompareProductContainer from '../components/compare-products.jsx';

const container = document.getElementById('product-compare-container');
if (container) {
  ReactDOM.render(React.createElement(CompareProductContainer), container);
}